/* Cristinita scroll animations */
(function(){
  if(!("IntersectionObserver" in window))return;
  var targets=document.querySelectorAll(
    ".featured-collection,.collection-list,.image-with-text,"+
    ".rich-text,.slideshow,.gallery,.newsletter,"+
    "[class*=section],[class*=banner],.shopify-section > div"
  );
  targets.forEach(function(el){
    if(el.closest("header")||el.closest("nav")||el.closest("#shopify-section-header"))return;
    el.classList.add("cc-animate-init");
  });
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add("cc-animate-in");
        obs.unobserve(e.target);
      }
    });
  },{threshold:0.12,rootMargin:"0px 0px -40px 0px"});
  targets.forEach(function(el){
    if(!el.closest("header")&&!el.closest("nav")&&!el.closest("#shopify-section-header")){
      obs.observe(el);
    }
  });
})();

/* CC-BLOG-HEADER-REVEAL-FIX (18 jul 2026)
   El encabezado "Blog Cristinita" a veces queda invisible porque su animacion
   nativa (Web Animations API via data-cc-animate) se atasca en currentTime:0
   sin nunca completar (bug puntual de ese overlay, no de CSS). Este fix:
   - actua SOLO sobre el overlay de la seccion .section-featured-blog
     (clase estable de Shopify por tipo de seccion, del schema del theme;
     NO depende del id numerico de la seccion, que puede cambiar).
   - espera 600ms para darle oportunidad real de terminar (dura 250ms normalmente).
   - solo cancela animaciones que sigan realmente atascadas
     (playState "running" Y currentTime 0) - nunca una animacion que ya progreso
     o ya termino normalmente.
   - no fuerza estilos inline: soltar (cancel) la animacion deja que el CSS
     existente (opacity:1!important de cc-animate-in) tome el control.
   - no toca ningun otro elemento con data-cc-animate.
   - no falla si la seccion no existe en la pagina. */
(function () {
  try {
    function checkAndFixBlogHeaderReveal() {
      var el = document.querySelector('.section-featured-blog .overlay');
      if (!el || !el.getAnimations) return;
      if (getComputedStyle(el).opacity === '1') return;
      el.getAnimations().forEach(function (a) {
        if (a.playState === 'running' && a.currentTime === 0) {
          a.cancel();
        }
      });
    }
    function schedule() { setTimeout(checkAndFixBlogHeaderReveal, 600); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else {
      schedule();
    }
  } catch (e) {}
})();


/* 30 sep 2026 (Macri): buscador desplegable — si escriben "camisa" o "camisas" solo salen camisas de niño (etiqueta "Niño Camisas") + 2 camisas de niña. La página de resultados se maneja en sections/main-search.liquid. */
(function(){
  var OK=['camisa-blanca-cruda','camisa-crudo','camisa-cuadros-y-rayas-rojo-y-azul','camisa-perrito-nata','camisa-cuadros-verde-bebe','camisa-cuadros-crema','camisa-cuadros-naranja','camisa-cuadros-plomo'];
  function isCam(q){return /^\s*camisas?\s*$/i.test(q||'');}
  function getQ(s){var m=/(?:^|[?&])q=([^&]*)/.exec(s||'');try{return m?decodeURIComponent(m[1].replace(/\+/g,' ')):'';}catch(e){return '';}}
  function hook(){
    var $=window.jQuery;
    if(!$||!$.ajaxPrefilter){return setTimeout(hook,250);}
    if($.__ccCamisas)return; $.__ccCamisas=1;
    $.ajaxPrefilter(function(o){
      if(!o.url||o.url.indexOf('/search/suggest')<0)return;
      var data=typeof o.data==='string'?o.data:'';
      if(!isCam(getQ(data)||getQ(o.url.split('?')[1])))return;
      if(data)o.data=data.replace(/(resources%5Blimit%5D|resources\[limit\])=\d+/,'$1=10');
      var prev=o.dataFilter;
      o.dataFilter=function(raw,type){
        if(prev)raw=prev(raw,type);
        try{
          var d=JSON.parse(raw),r=d.resources&&d.resources.results;
          if(r){
            if(r.products){r.products=r.products.filter(function(p){var t=(p.tags||[]).map(function(x){return String(x).toLowerCase();});return t.indexOf('niño camisas')>-1||OK.indexOf(p.handle)>-1;}).slice(0,5);}
            r.pages=[];r.articles=[];r.collections=[];
          }
          return JSON.stringify(d);
        }catch(e){return raw;}
      };
    });
  }
  hook();
})();

/* Agotados fuera de la busqueda rapida (14 oct 2026, Macri) */
(function(){
  function hook(){
    var $=window.jQuery;
    if(!$||!$.ajaxPrefilter){return setTimeout(hook,250);}
    if($.__ccHideSold)return; $.__ccHideSold=1;
    $.ajaxPrefilter(function(o){
      if(!o.url||o.url.indexOf('/search/suggest')<0)return;
      var p='resources%5Boptions%5D%5Bunavailable_products%5D=hide';
      if(typeof o.data==='string'&&o.data){ if(o.data.indexOf('unavailable_products')<0)o.data+='&'+p; }
      else if(o.url.indexOf('unavailable_products')<0){ o.url+=(o.url.indexOf('?')<0?'?':'&')+p; }
    });
  }
  hook();
})();


/* 16 oct 2026 (Macri: "pongo robot, le doy click a una opcion y a veces no se abre").
   El tema cierra la lista de sugerencias 100 ms despues de que el buscador pierde el foco.
   En Safari/iPhone un clic en un enlace no le da foco, asi que la lista se cerraba antes de que el clic llegara.
   Arreglo: (1) con mouse, el mousedown sobre una sugerencia no le quita el foco al buscador;
   (2) en pantalla tactil, un toque (sin arrastrar) sobre una sugerencia abre el enlace directo. */
(function(){
  var SEL = '.search-bar__results a[href]';
  function linkOf(e){ return e.target && e.target.closest ? e.target.closest(SEL) : null; }
  document.addEventListener('mousedown', function(e){ if (e.button === 0 && linkOf(e)) e.preventDefault(); }, true);
  var t0 = null;
  document.addEventListener('touchstart', function(e){
    var a = linkOf(e); if (!a || !e.touches || !e.touches[0]) { t0 = null; return; }
    t0 = { a: a, x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { capture: true, passive: true });
  document.addEventListener('touchend', function(e){
    if (!t0) return; var c = e.changedTouches && e.changedTouches[0]; var a = t0.a; var moved = !c || Math.abs(c.clientX - t0.x) > 10 || Math.abs(c.clientY - t0.y) > 10; t0 = null;
    if (moved) return;
    e.preventDefault(); window.location.href = a.href;
  }, { capture: true, passive: false });
})();
